/**
 * AllMeters created by karora on 28/03/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from '../app.component';

@Component({
  selector: 'all-issues',
  template: '<issues-stats></issues-stats><hub-issues></hub-issues>',
  styles: [],
})

export class AllIssuesComponent implements OnInit {
  @Input()
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    document.getElementById('title').innerText = 'All Issues';
  }

}
